export default state => state.identity.isAuthenticated;
